import { tutorModule } from '@/store/tutor/module'
import { isPromise } from '@/store/utils'
import { userModule } from '@/store/user/module'
import { quizModule } from '@/store/quiz/module'

const getChat = () => {
    return tutorModule.state.chat
}

const getPageReferences = () => {
    const textbookSearchResults = tutorModule.state.textbookSearch.results
    if (isPromise(textbookSearchResults)) {
        return []
    } else {
        return textbookSearchResults
    }
}

const getChatUuid = (questionSerial?: string, currentExamMetadataId?: string) => {
    const currentUser = userModule.state.user
    const activeQuiz = quizModule.getters.getActiveQuiz()
    if (
        !currentUser?.objectId
        || !currentExamMetadataId
        || !questionSerial
        || !activeQuiz?.startedAt
    ) {
        return null
    }

    return `${currentUser.objectId}_${currentExamMetadataId}_${questionSerial}_${activeQuiz?.startedAt}`
}

export default {
    getChat,
    getPageReferences,
    getChatUuid,
}
